import React, { useMemo } from 'react';
import BalanceUpEnroll from './BalanceUpEnroll';
import { BALANCE_UP_STEPS_MAP } from '../constants';
import BalanceUpDashboard from './BalanceUpDashboard';
import { OverdraftDetails } from '../../../types';

interface IProps {
  activeStep: number;
  handleStepSubmit: (type: number) => void;
  enrollmentType: string;
  overdraftObject: OverdraftDetails;
}

const BalanceUpStepSwitch = ({ activeStep, handleStepSubmit, enrollmentType, overdraftObject }: IProps) => {
  const { eligible: isEligible, eligibilityLimit } = overdraftObject;
  const onStepSubmit = (type: number) => {
    handleStepSubmit(type);
  };

  return useMemo(() => {
    switch (activeStep) {
      case BALANCE_UP_STEPS_MAP.ZERO_STATE:
        return <div hidden />;
      case BALANCE_UP_STEPS_MAP.ENROLLMENT:
        return (
          <BalanceUpEnroll
            overDraftLimit={eligibilityLimit}
            enrollmentType={enrollmentType}
            isEligible={isEligible}
            handleEnroll={onStepSubmit}
          />
        );
      case BALANCE_UP_STEPS_MAP.BALANCE_UP_DASHBOARD:
        return <BalanceUpDashboard overdraftObject={overdraftObject} />;
      default:
        return <div hidden />;
    }
  }, [activeStep, overdraftObject]);
};

export default BalanceUpStepSwitch;
